import React, { useEffect, useState } from 'react';
import { ArrowLeft, ArrowRight } from '@phosphor-icons/react';
import { Link, useParams } from 'react-router-dom';
import { apiService, getImageUrl } from '../../config/api';
import { useI18n } from '../../i18n';

const BlogPost = () => {
  const { id } = useParams();
  const { isRTL, t } = useI18n();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    apiService.get(`/blog/${id}`)
      .then((response) => { if (active) setPost(response); })
      .catch((error) => { console.error('Error fetching blog post:', error); if (active) setPost(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [id]);

  if (loading) return <div className="tafsir-page"><div className="page-shell skeleton-line min-h-[70vh]" /></div>;

  if (!post) {
    return <div className="tafsir-page"><div className="page-shell quiet-surface px-6 py-20 text-center"><h1 className="font-display text-4xl font-semibold">Article not found</h1><Link to="/blog" className="btn-primary mt-7">{t('common.back')}</Link></div></div>;
  }

  return (
    <article className="tafsir-page">
      <div className="page-shell">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm font-medium text-text-secondary hover:text-primary">
          {isRTL ? <ArrowRight size={17} /> : <ArrowLeft size={17} />} {t('common.blog')}
        </Link>
        <header className="mx-auto mt-10 max-w-5xl text-center">
          <p className="editorial-eyebrow mb-4">{post.category}</p>
          <h1 className="editorial-title">{post.title}</h1>
          <p className="mt-6 text-sm text-text-secondary">{post.author}{post.createdAt ? ` · ${new Date(post.createdAt).toLocaleDateString()}` : ''}</p>
        </header>
        <div className="mx-auto mt-10 max-w-6xl overflow-hidden bg-surface">
          <img src={post.featuredImage || getImageUrl('/Images/1-The Art of Patience_WhatsApp Image 2024-08-12 at 19.03.36.jpeg')} alt={post.title} className="max-h-[72vh] w-full object-cover" />
        </div>
        <div className="mx-auto mt-12 max-w-3xl font-display text-xl leading-9 text-text-secondary">
          {(post.content || '').split('\n\n').map((paragraph, index) => <p key={index} className="mb-7">{paragraph}</p>)}
        </div>
      </div>
    </article>
  );
};

export default BlogPost;
